import React, { useRef } from "react";
import { useParams } from "react-router-dom";
import PortfolioDetailsV2 from "./PortfolioDetailsV2";

const PortfolioV2 = () => {
  const { fundName, strategyName } = useParams();
  const exportRef = useRef(null);

  return (
    <PortfolioDetailsV2
      fundName={fundName}
      strategyName={strategyName}
      exportRef={exportRef}
    />
  );
};

export default PortfolioV2;
